/* eslint-disable @typescript-eslint/no-explicit-any */
export type ApiContext = {
  baseUrl: string;
  getAuthToken: () => Promise<string | undefined>;
  signOut: () => Promise<void>;
};

export const getApiContextSafe = (): ApiContext => {
  return (globalThis as any).EA_API_CONTEXT;
};

export const getApiContext = (): ApiContext => {
  if (!(globalThis as any).EA_API_CONTEXT) throw new Error("EA_API_CONTEXT not set");

  return (globalThis as any).EA_API_CONTEXT;
};

export const setApiContext = (apiContext: ApiContext) => {
  (globalThis as any).EA_API_CONTEXT = apiContext;
};

export const IS_SERVER_CONTEXT = typeof window === "undefined";
